module.exports = __webpack_public_path__ + "static/media/seat-wheelchair-symbol.fd37a929.svg";